<div id="buttons" class="button">
  <ng-content></ng-content>
</div>
